import axios from 'axios';
import { AdresseIP } from './AdresseIp';

export class ChambreService {

    constructor(){
        this.adresse = new AdresseIP()
    }
    
    getAll() {
        
        return axios.get(this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/chambre')
                    .then(res => res.data);
    }
    create(newChambre) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/chambre'
        return axios.post(url,newChambre)
                    .then(res => res.data);
    }
    update(idChambre ,newChambre) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/chambre/'
        return axios.put(url+idChambre, newChambre)
                    .then(res => res.data);
    }
    delete(idChambre) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/chambre/'
        return axios.patch(url+idChambre)
                    .then(res => res.data)
    }
    get(idCouloir) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/chambre/?idCouloir='+idCouloir
        return axios.get(url)
                    .then(res => res.data)
    }

}